import Popover from "../../../gd-components/gd-popover/popover"
import React from "react"
import ProjectSession from "../../../model2/project/project-session"
import {findDOMNode} from "react-dom"
import {PopoverMenuItemType} from "../../../gd-components/popover-menu/popover-menu/const"
import ProjectStatusManager from "../../../gd/manager/project-status-manager"
import UserStars from "../../../manager/user/stars"
import MoreProject_PopoverColorIcon from "./popover-color-icon"
import delete_project from "./actions/delete-project"
import MoreProject_PopoverMenu from "./popover-menu"
import {PopoverAttachmentType} from "../../../gd-components/gd-popover/@const";

type Props = {
    hidePopover              : callback
    project                  : ProjectSession
    parent                   : any // must have hide popover
    attachment?              : string
    targetAttachment?        : string
    targetOffset?            : string
    attachmentType?          : PopoverAttachmentType
    showPinStar?             : boolean
    outsideClickIgnoreClass? : string
}

// const debug = "MoreProject_Popover"
const debug = false

export default function MoreProject_Popover(props:Props) {

    return (
        <Popover popoverClass               = "project-more-popover"
                 className                  = "project-more-popover-container"
                 attachment                 = {!!props.attachment ? props.attachment : "top center"}
                 targetAttachment           = {!!props.targetAttachment ? props.targetAttachment : "bottom center"}
                 targetOffset               = {!!props.targetOffset ? props.targetOffset : "0 0"}
                 outsideClickIgnoreClass    = {props.outsideClickIgnoreClass}
                 attachmentType             = {!!props.attachmentType ? props.attachmentType : PopoverAttachmentType.HORIZONTAL}
                 arrowsVersion              = {2}
                 getTargetFunc              = {()=>findDOMNode(props.parent)}
                 onClickOutside             = {props.hidePopover}>

            <MoreProject_PopoverMenu project        = {props.project}
                                     hidePopover    = {props.hidePopover}/>

        </Popover>
    )
}
